// https://github.com/parcel-bundler/parcel/issues/3644#issuecomment-542117712
import $ from 'jquery/dist/jquery.js';
globalThis.$= $;
globalThis.jQuery = $;
